import type { ReactElement } from 'react';
import { useState, useEffect } from 'react';
import ReproveMain from './features/reprove/ReproveMain';
import ReportsView from './views/ReportsView';

type AppSection = 'reprove' | 'reports';

interface AppRouterProps {
  onBack?: () => void;
  onNavigate?: (section: 'reprove' | 'reports' | 'admin') => void;
}

const AppRouter = ({ onBack, onNavigate }: AppRouterProps): ReactElement => {
  const [currentSection, setCurrentSection] = useState<AppSection>('reprove');

  // 🔥 Escuchar evento para navegar a Reports
  useEffect(() => {
    const handleNavigateToReports = () => {
      setCurrentSection('reports');
    };

    window.addEventListener('navigateToReports', handleNavigateToReports);
    return () => {
      window.removeEventListener('navigateToReports', handleNavigateToReports);
    };
  }, []);

  // 🔥 NUEVO: Escuchar evento para navegar a Reprove
  useEffect(() => {
    const handleNavigateToReprove = () => {
      setCurrentSection('reprove');
    };

    window.addEventListener('navigateToReprove', handleNavigateToReprove);
    return () => {
      window.removeEventListener('navigateToReprove', handleNavigateToReprove);
    };
  }, []);

  const handleNavigation = (section: 'reprove' | 'reports' | 'admin'): void => {
    // Solo cambiar sección si es reprove o reports
    if (section === 'reprove' || section === 'reports') {
      setCurrentSection(section);
    }

    // Propagar al Dashboard
    if (onNavigate) {
      onNavigate(section);
    }
  };

  const handleBack = (): void => {
    if (onBack) {
      onBack();
    } else {
      setCurrentSection('reprove');
      if (onNavigate) {
        onNavigate('reprove');
      }
    }
  };

  const handleReproveToReports = (): void => {
    handleNavigation('reports');
  };

  const handleReportsToReprove = (): void => {
    handleNavigation('reprove');
  };

  return (
    <>
      {currentSection === 'reprove' && (
        <ReproveMain
          onBack={handleBack}
          onNavigateToReports={handleReproveToReports}
        />
      )}

      {currentSection === 'reports' && (
        <ReportsView
          onBack={handleBack}
          onNavigateToReprove={handleReportsToReprove}
          onNavigate={handleNavigation}
        />
      )}
    </>
  );
};

export default AppRouter;
